export default __webpack_public_path__ + "static/media/mobile-right.8b909fbc.svg";